export default "__VITE_ASSET__BSSgB_GX__"